// extracted by mini-css-extract-plugin
export default {"amenitiesRow":"buses_amenitiesRow__gqgF-","searchHeader":"buses_searchHeader__qA6yS"};